import styled from "styled-components";
import { colors } from "../../../theme";

interface ITextProps {
  size?: number;
  color?: string;
  weight?: number;
}

const Text = styled.p.withConfig({
  displayName: "Text",
})`
  font-weight: ${({ weight }: ITextProps) => weight || 400};
  font-size: ${({ size }: ITextProps) => size || 24}px;
  text-align: center;
  color: ${({ color }: ITextProps) => color || colors.white};
  white-space: pre-line;
`;

export default Text;
